/* eslint-disable */
/* tslint:disable */
import PropTypes from 'prop-types';
import React from 'react';
import LikeHeart from 'wix-ui-icons-common/on-stage/LikeHeart';
var love_empty = function (_a) { return (React.createElement(LikeHeart, { size: "24" })); };
love_empty.displayName = 'love_empty';
love_empty.propTypes = {
    size: PropTypes.string
};
export default love_empty;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=love_empty.js.map